import React, {useState} from "react"
import Accusation from "./Accusation"

function PartSeven(props) {
    const blueprints = [
        "bruce",
        "dorris",
        "harriette",
        "logan",
        "mary",
        "nigel",
        "tara"
    ]
    const [currentImage, setCurrentImage] = useState(0)
    
    function changeImage(event) {
        const {id} = event.target
        if (id === "rightArrow") {
            if (currentImage < (blueprints.length-1)) { 
                setCurrentImage(prevImage => prevImage + 1)
            } else {
                setCurrentImage(0)
            }
        } else {
            if (currentImage > 0) {
                setCurrentImage(prevImage => prevImage - 1)
            } else {
                setCurrentImage(blueprints.length-1)
            }
        }
    }
    
    function triggerOverlay() {
        const show = "on"
        const text = "Tara Smythe has been arrested and is being interviewed by the NYPD."
        const trigger = "blueprints"
        const complete = true
        props.callBackOverlay(show, text, trigger)
        props.callBackStatus(trigger, complete)
        props.callBackRevealClues("Hideout Locations", "The Blueprint Puzzle")
    }
    
    return (
        <div>
            <h3 className="centerText">We now know the thief is one of three suspects. Harriette Watts, Tara Smythe or Mary Floyd. Only one of them had a clear route to the diamond without being seen.</h3>

            <div className="imageTextWrapper knownLocations">
                <img className="placeholderImage locationImage" alt="suspect location" src={"images/blueprints/" + blueprints[currentImage] + ".jpg"} />
                <div className="arrowButton" onClick={changeImage} id="leftArrow"></div>
                <div className="arrowButton" onClick={changeImage} id="rightArrow"></div>  
            </div>

            <h3 className="centerText">As part of your accusation we need their route code. Each room in the museum equates to a number. To decypher the route code: enter the number of each room the thief moved through, in order, including their starting and finishing room.</h3>
        
            <Accusation callBackSubmit={triggerOverlay} />
        </div>
    )
}

export default PartSeven